import React from 'react';
import { useTheme } from 'styled-components';

const CheckListIcon = ({ size = 14, rotate = 'down' }) => {
  const theme = useTheme();
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.70703 9.79997L7.70703 10.8L10.3737 8.1333"
        stroke={theme?.actionsIconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.16732 4.00004H9.83398C11.1673 4.00004 11.1673 3.33337 11.1673 2.66671C11.1673 1.33337 10.5007 1.33337 9.83398 1.33337H7.16732C6.50065 1.33337 5.83398 1.33337 5.83398 2.66671C5.83398 4.00004 6.50065 4.00004 7.16732 4.00004Z"
        stroke={theme?.actionsIconColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1667 2.68005C13.3867 2.80005 14.5 3.62005 14.5 6.66672V10.6667C14.5 13.3334 13.8333 14.6667 10.5 14.6667H6.5C3.16667 14.6667 2.5 13.3334 2.5 10.6667V6.66672C2.5 3.62672 3.61333 2.80005 5.83333 2.68005"
        stroke={theme?.actionsIconColor}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CheckListIcon;
